import React from "react";
import "../css/reset.css";
import "../css/service.css";

const skillListsData = [
  {
    title: "개발기술",
    skills: [
      "React-native",
      "firebase",
      "Kotlin",
      "nodejs",
      "react",
      "Django",
      "python",
      "AWS",
      "mySQL",
      "Postgresql",
      "Chat GPT",
      "Gemini",
    ],
  },
  {
    title: "운영체제",
    skills: ["Android", "iOS", "Linux", "Window"],
  },
];

const Service2 = () => {
  return (
    <>
      <section
        className="service2_wrap"
        id="serviceSection2"
        name="serviceSection2"
      >
        <div className="service2_inner">
          <div className="title_wrap">
            <h3>SERVICE 2.</h3>
            <strong>서비스 기술</strong>
          </div>

          <div className="service2_produce_wrap">
            <p>
              데이터파이브는 다양한 보유기술과 여러 운영체제를 지원하고
              있습니다.
            </p>
          </div>

          <div className="service2_content_wrap">
            {skillListsData.map((list, index) => (
              <span key={index}>
                <div className="list_frame">
                  <div className="list_frame_title_wrap">
                    <h4>{list.title}</h4>
                  </div>
                  <div className="list_frame_inner">
                    <ul>
                      {list.skills.map((skill, skillIndex) => (
                        <li key={skillIndex}>
                          <span>{skill}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {index < skillListsData.length - 1 && <hr />}
              </span>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Service2;
